import React from 'react'
import {
    Box,
    IconButton,
    Tooltip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
} from '@material-ui/core'
import { Visibility as ViewIcon, Link as LinkIcon } from '@material-ui/icons'

import { LeaseDocument } from '../../types'
import { useUnpairedSearchDocumentsTableStyles } from './styles'
interface UnpairedSearchDocumentsTableProps {
    documents: LeaseDocument[]
    onViewDocument: (doc: LeaseDocument) => void
    onPairDocument: (documentId: number) => void
}

export const UnpairedSearchDocumentsTable: React.FC<UnpairedSearchDocumentsTableProps> = ({
    documents,
    onViewDocument,
    onPairDocument,
}) => {
    const classes = useUnpairedSearchDocumentsTableStyles()

    // Sort documents by title
    const sortedDocuments = [...documents].sort((a, b) => {
        const titleA = a.title || a.file_name || ''
        const titleB = b.title || b.file_name || ''
        return titleA.localeCompare(titleB)
    })

    return (
        <Box style={{ width: '100%' }}>
            <TableContainer
                component={Paper}
                className={classes.tableContainer}
            >
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.headerCell}>
                                Resident
                            </TableCell>
                            <TableCell className={classes.headerCell}>
                                Start
                            </TableCell>
                            <TableCell className={classes.headerCell}>
                                End
                            </TableCell>
                            <TableCell className={classes.headerCell}>
                                Title
                            </TableCell>
                            <TableCell
                                className={classes.headerCell}
                                align="center"
                            >
                                Pages
                            </TableCell>
                            <TableCell className={classes.headerCell}>
                                Signature Date
                            </TableCell>
                            <TableCell
                                className={classes.headerCell}
                                align="center"
                            >
                                Actions
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedDocuments.map((doc: LeaseDocument) => (
                            <TableRow key={doc.id} hover>
                                <TableCell>{doc.resident}</TableCell>
                                <TableCell>{doc.lease_start}</TableCell>
                                <TableCell>{doc.lease_end}</TableCell>
                                <TableCell className={classes.titleCell}>
                                    <Tooltip title={doc.title || 'No title'}>
                                        <span>{doc.title || '-'}</span>
                                    </Tooltip>
                                </TableCell>
                                <TableCell align="center">
                                    {doc.page_count || '-'}
                                </TableCell>
                                <TableCell>
                                    {(doc as any).signature_date || ''}
                                </TableCell>
                                <TableCell align="center">
                                    <Box className={classes.actionButtons}>
                                        <Tooltip title="View PDF">
                                            <IconButton
                                                size="small"
                                                onClick={() =>
                                                    onViewDocument(doc)
                                                }
                                            >
                                                <ViewIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            color="primary"
                                            startIcon={<LinkIcon />}
                                            onClick={() =>
                                                onPairDocument(doc.id)
                                            }
                                        >
                                            Pair
                                        </Button>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}
